<template>
  <v-card>
    <v-card-title>
      {{title}}
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.url"
              :label="$t('document.url')"
              dense
              outlined
              @change="$v.form.url.$touch()"
              :error-messages="errorMessages('url')"
            />
          </v-col>
        </v-row>
        <v-row align="baseline">
          <v-col>
            <v-text-field
              v-model="form.name"
              :label="$t('document.name')"
              dense
              outlined
              :disabled="useLinkFilename"
              @input="$v.form.name.$touch()"
              :error-messages="errorMessages('name')"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="useLinkFilename"
              dense
              :disabled="!linkFilename"
              :label="$t('document.filenameFromLink')"
              @change="$v.form.name.$touch()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.description"
              :label="$t('common.description')"
              dense
              hide-details
              outlined
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        rounded
        dark
        dense
        outlined
        color="primary"
        @click="cancel"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <SubmitButton @click="submit" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { errorMessageGenerator, documentModel } from '@/validators'

export default {
  name: 'DocumentForm',
  props: {
    title: {
      type: String,
      default: 'Add document'
    },
    value: {
      type: Object,
      default: () => ({
        name: '',
        description: '',
        url: ''
      })
    }
  },
  data () {
    return {
      useLinkFilename: this.value.id ? this.value.name === this.value.url.match(process.env.VUE_APP_FILENAME_REGEX) : false,
      form: { ...this.value }
    }
  },
  computed: {
    linkFilename () {
      if (!this.$v.form.url.$invalid) {
        const filenames = this.form.url.match(process.env.VUE_APP_FILENAME_REGEX)
        return filenames ? filenames[0] : null
      } else {
        return null
      }
    }
  },
  methods: {
    errorMessages (key) {
      return errorMessageGenerator(this.$v.form[key], key)
    },
    cancel () {
      this.$v.$reset()
      this.$eventBus.$emit('CLOSE_MODAL')
      this.form = { ...this.value }
    },
    async submit () {
      this.form.creationDate = new Date()
      await this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.form.name = this.form.name || this.linkFilename
        this.$emit('SAVE_DOCUMENT', this.form)
        this.$v.$reset()
        this.useLinkFilename = false
        this.form = { ...this.value }
      }
    }
  },
  watch: {
    value (v) {
      this.form = { ...v }
      this.useLinkFilename = v.id ? v.name === this.linkFilename : false
    },
    useLinkFilename () {
      this.form.name = this.linkFilename
    }
  },
  validations: documentModel
}
</script>

<style scoped>
.v-dialog > .v-card > .v-card__text {
  padding: 24px 20px;
}
</style>
